import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';
import { FETCH_POLICY } from 'common/apollo/FETCH_POLICY';
import {
  GET_MAPPED_JOB_PROFILES,
  GET_CLASSIFICATIONS,
  MappedJobProfilesData,
  ClassificationsData
} from './jobProfiles.mutations';

const ALL_PROFILES = 10000;

export const useGetAllJobProfiles = () => {
  const [fetchJobProfiles, { data: jobProfilesData, loading: loadingJobProfiles }] = useLazyQuery<
    MappedJobProfilesData,
    { search?: string; limit: number; offset: number }
  >(GET_MAPPED_JOB_PROFILES, { fetchPolicy: FETCH_POLICY.CACHE_FIRST });

  const [fetchClassifications, { data: classificationsData, loading: loadingClassifications }] =
    useLazyQuery<ClassificationsData>(GET_CLASSIFICATIONS, { fetchPolicy: FETCH_POLICY.CACHE_FIRST });

  const loadJobProfiles = useCallback(() => {
    fetchJobProfiles({ variables: { limit: ALL_PROFILES, offset: 0 } });
  }, [fetchJobProfiles]);

  return {
    jobProfiles: jobProfilesData?.jobProfiles?.jobProfiles || [],
    classifications: classificationsData?.classifications?.classifications || [],
    loadingJobProfiles,
    loadingClassifications,
    loadJobProfiles,
    loadClassifications: fetchClassifications
  };
};
